<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Onboard Partner
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2" @submit.prevent="sendCall">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="partnerFirstName">First Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="partnerFirstName"
                      v-model="formData.firstName"
                      v-validate="'required|min:2|max:25'"
                      name="firstName"
                      data-vv-as="first name"
                      :class="errorBag.has('firstName') ? 'is-invalid' : ''"
                      placeholder="Enter first name"
                    />
                    <small v-show="errorBag.has('firstName')" class="invalid-feedback">
                      {{ errorBag.first('firstName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="partnerLastName">Last Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="partnerLastName"
                      v-model="formData.lastName"
                      v-validate="'required|min:2|max:25'"
                      name="lastName"
                      data-vv-as="last name"
                      :class="errorBag.has('lastName') ? 'is-invalid' : ''"
                      placeholder="Enter last name"
                    />
                    <small v-show="errorBag.has('lastName')" class="invalid-feedback">
                      {{ errorBag.first('lastName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="partnerBusinessName">Business Name <small class="text-muted">(optional)</small></label>
                    <input
                      type="text"
                      class="form-control"
                      id="partnerBusinessName"
                      v-model="formData.businessName"
                      v-validate="'max:100'"
                      name="businessName"
                      data-vv-as="business name"
                      :class="errorBag.has('businessName') ? 'is-invalid' : ''"
                      placeholder="Enter business name"
                    />
                    <small v-show="errorBag.has('businessName')" class="invalid-feedback">
                      {{ errorBag.first('businessName') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="partnerEmail">Email <span class="text-danger">*</span></label>
                    <input
                      type="email"
                      class="form-control"
                      id="partnerEmail"
                      v-model="formData.email"
                      v-validate="'required|email'"
                      name="email"
                      :class="errorBag.has('email') ? 'is-invalid' : ''"
                      placeholder="Enter email"
                    />
                    <small v-show="errorBag.has('email')" class="invalid-feedback">
                      {{ errorBag.first('email') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="partnerPhoneNumber">Phone Number <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      id="partnerPhoneNumber"
                      v-model="formData.phoneNumber"
                      v-validate="'required'"
                      name="phoneNumber"
                      data-vv-as="phone number"
                      :class="errorBag.has('phoneNumber') ? 'is-invalid' : ''"
                      placeholder="Enter phone number"
                    />
                    <small v-show="errorBag.has('phoneNumber')" class="invalid-feedback">
                      {{ errorBag.first('phoneNumber') }}
                    </small>
                  </div>
                </div>
                <div class="col-md-6" v-for="field in rateFields" :key="field.name">
                  <div class="form-group">
                    <label :for="'partner-' + field.name">{{ field.label }} <span class="text-danger">*</span></label>
                    <input
                      type="number"
                      step="any"
                      min="0"
                      max="100"
                      class="form-control"
                      :id="'partner-' + field.name"
                      v-model="formData[field.name]"
                      v-validate="'required|decimal|min_value:0|max_value:100'"
                      :name="field.name"
                      :data-vv-as="field.label.toLowerCase()"
                      :class="errorBag.has(field.name) ? 'is-invalid' : ''"
                      :placeholder="field.placeholder"
                    />
                    <small v-show="errorBag.has(field.name)" class="invalid-feedback">
                      {{ errorBag.first(field.name) }}
                    </small>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-center">
            <button type="button" class="btn btn-secondary mr-1" @click="$emit('hide')" :disabled="loading">
              Cancel
            </button>
            <button type="button" class="btn btn-primary mr-1 d-flex" @click="sendCall" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
              {{ loading ? 'Creating...' : 'Create Partner' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
const RATE_FIELDS = [
  { name: 'domesticBuyingRate', label: 'Domestic Buying Rate', placeholder: 'e.g. 1.5' },
  { name: 'domesticSellingRate', label: 'Domestic Selling Rate', placeholder: 'e.g. 1.7' },
  { name: 'internationalBuyingRate', label: 'International Buying Rate', placeholder: 'e.g. 2.5' },
  { name: 'internationalSellingRate', label: 'International Selling Rate', placeholder: 'e.g. 2.7' }
]

export default {
  props: ['show'],
  data() {
    return {
      loading: false,
      rateFields: RATE_FIELDS,
      formData: this.emptyForm()
    };
  },
  methods: {
    emptyForm() {
      let form = {
        firstName: '',
        lastName: '',
        businessName: '',
        email: '',
        phoneNumber: ''
      }
      RATE_FIELDS.forEach(field => {
        form[field.name] = ''
      })
      return form
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return
        }
        this.loading = true;
        let requestData = {
          firstName: this.formData.firstName,
          lastName: this.formData.lastName,
          email: this.formData.email,
          phoneNumber: this.formData.phoneNumber
        };
        RATE_FIELDS.forEach(field => {
          requestData[field.name] = this.formData[field.name]
        });

        if (this.formData.businessName) {
          requestData.businessName = this.formData.businessName;
        }

        this.makeRequest('post', 'v1/onboard-partner', requestData).then(callResponse => {
          this.loading = false;
          if (!callResponse.error && callResponse.response.data.code == 200) {
            this.$emit('partnerCreated');
            this.$emit('hide');
          }
        });
      });
    },
    resetForm() {
      this.formData = this.emptyForm();
      this.$nextTick(() => {
        this.$validator.reset();
      })
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.resetForm();
      }
    }
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
}

.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  overflow-y: auto;
}
</style>
